import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isRemoveTaskStatusRequestFailure() {
      return getState().request.isFailure;
    },
    isRemoveTaskStatusRequestPending() {
      return getState().request.isPending;
    },
    isRemoveTaskStatusRequestSuccess() {
      return getState().request.isSuccessful;
    },
  };
}

export { createSelector };
